<div class="shis-grid-actiondropdown" [ngClass]="elemID">
    <button class="dropdown-button" [ngClass]="disabled ? 'in-active' : 'active'" [disabled]="disabled" (click)="toggleMenu($event)">
        &#x22EE; <!-- Ellipsis icon -->
    </button>
    <div class="dropdown-menu" *ngIf="isOpen" >
        <a *ngFor="let item of ShowItems" [ngClass]="item.disabled ? 'in-active' : 'active'" href="javascript:void(0)" (click)="onActionSelect(item)">{{ item.label }}</a>
    </div>
</div>